import React from 'react';

class renderEmailField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      initialized: true
    }
  }

  componentWillMount() {
    if (this.props.defaultValue) {
      this.props.input.onChange(this.props.defaultValue);
    }
    this.setState({initialized: true});
  }

  componentWillUnmount() {
    this.setState({initialized: false});
  }

  // VE-7248: Prevent space key input
  handleKeyDown = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  }

  // VE-7248: Trim whitespace from email input in real-time
  handleEmailChange = (e) => {
    const value = e.target ? e.target.value : '';
    const trimmed = value.replace(/\s/g, '');
    this.props.input.onChange(trimmed);
  }

  render() {
    const {
      className,
      placeholder,
      input,
      type,
      id,
      disabled,
      meta: { touched, error, warning, asyncValidating },
      getRef,
      ...rest
    } = this.props;

    return (
      <div className={`${asyncValidating ? 'async-validating' : ''}`}>
        <input
          id={id}
          placeholder={placeholder}
          type={type}
          disabled={ !!disabled }
          ref={getRef}
          className={`${className ? className : '' } ${touched && error ? 'invalid' : ''} ${disabled && 'v-cursor-not-allowed'}`}
          max={(type === 'date') ? "2999-12-31" : undefined}
          value={input.value}
          onChange={this.handleEmailChange}
          onKeyDown={this.handleKeyDown}
          onBlur={input.onBlur}
          onFocus={input.onFocus}
          name={input.name}
        />
        <span className="field-validation-message">
          {touched &&
            (error && <span>{error}</span>)}
        </span>
        <span className="field-validation-message font-weight-bold font-italic text-warning">
          {touched &&
            (warning && <span>{warning}</span>)}
        </span>
      </div>
    );
  }
}

export default renderEmailField;